import React, { useRef } from "react";
import HorizontalBarChart from "./Template/HorizontalBarChart";
import HorizontalBarWithTable from "./Template/HorizontalBarWithTable";
import CustomChartView from "./Template/CustomChartView";
import VerticalBarWithPercentage from "./Template/VerticalBarWithPercentage";
import PieChartVersion1 from "./Template/PieChartVersion1";
import PieChartVersion2 from "./Template/PieChartVersion2";
import VerticalBarChartGender from "./Template/VerticalBarChartGender";
import HorizontalBarSimple from "./Template/HorizontalBarSimple";
import html2canvas from "html2canvas";
import { uploadFile } from "../../store/uploadFile";
import { useDispatch, useSelector } from "react-redux";
import useGraphStore from "../../store/zustandStore/graphZs";
import HorizontalBarWithTableTest from "./Template/HorizontalBarWithTable";
import { getCategoryLabelById } from "../../utils/labelsById";
import BarChartVertical from "./Template/BarChartVertical";
import HorizontalBar2Value from "./Template/HorizontalBar2Value";
import HorizontalBarMultiWithTable from "./Template/HorizontalBarMultiWithTable";
import MultiPieChart from "./Template/MultiPieChart";

export const CHARTS_TEMPLATE = [
  { id: "horizontal-bar-2-value", label: "Horizontal Bar 2 vlera" },
  // { id: "horizontal-bar-table", label: "Horizontal Bar me Tabele" },
  { id: "vertical-bar-percentage", label: "Vertikal Bar me Perqindje" },
  { id: "custom-chart", label: "Custom Bar" },
  { id: "pie-version-1", label: "Pie Version 1" },
  { id: "pie-version-2", label: "Pie Version 2" },
  { id: "vertical-bar-gender", label: "Vertikal Bar Gjinia" },
  { id: "horizontal-bar-simple", label: "Horizontal Bar e thjeshte" },
  {
    id: "horizontal-bar-with-table",
    label: "Horizontal Bar me Tabele",
  },
  {
    id: "horizontal-bar-multi-with-table",
    label: "Horizontal bar multi me tabele",
  },
  {
    id: "multi-pie-1",
    label: "Multi Pie",
  },
];

export const SwitchCustomChart = ({
  dataChart,
  chartTemplateId,
  name,
  title,
  formFormulaId,
  year,
}) => {
  const chartRef = useRef();

  const chartDataList = Object.entries(dataChart).map(([values]) => ({
    ...values,
  }));

  return (
    <div>
      <div ref={chartRef}>
        {(() => {
          switch (chartTemplateId) {
            case "horizontal-bar":
              return <HorizontalBarChart dataChart={dataChart} />;

            // return chartDataList.map(({ category, dataChart }) => (
            //   <div key={category}>
            //     <h3>{category}</h3>
            //     <HorizontalBarChart dataChart={dataChart} />
            //   </div>
            // ));

            case "horizontal-bar-table":
              // return <HorizontalBarWithTable dataChart={dataChart} />;
              return chartDataList.map(({ dataChart }) => (
                <div>
                  <HorizontalBarWithTable dataChart={dataChart} />
                </div>
              ));
            case "custom-chart":
              return <CustomChartView dataChart={dataChart} />;
            case "vertical-bar-gender":
              return (
                <div>
                  {dataChart?.all?.map((entry, idx) => (
                    <VerticalBarChartGender
                      key={idx}
                      title={idx}
                      dataSetting={{
                        chartTemplate: "vertical-bar-gender",
                        name: name,
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      entry={entry}
                    />
                  ))}
                </div>
              );
            case "horizontal-bar-simple":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <HorizontalBarSimple
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "horizontal-bar-simple",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      dataChart={value}
                    />
                  ))}
                </div>
              );
            case "horizontal-bar-with-table":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <HorizontalBarWithTable
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "horizontal-bar-with-table",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      dataChart={value}
                    />
                  ))}
                </div>
              );
            case "pie-version-2":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <PieChartVersion2
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "pie-version-2",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      dataChart={value}
                    />
                  ))}
                </div>
              );
            case "pie-version-1":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <PieChartVersion1
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "pie-version-1",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      dataChart={value}
                    />
                  ))}
                </div>
              );
            case "vertical-bar-percentage":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <VerticalBarWithPercentage
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "vertical-bar-percentage",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      dataChart={value}
                    />
                  ))}
                </div>
              );

            case "horizontal-bar-2-value":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <HorizontalBar2Value
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "horizontal-bar-2-value",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      data={value}
                    />
                  ))}
                </div>
              );
            case "horizontal-bar-multi-with-table":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <HorizontalBarMultiWithTable
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "horizontal-bar-multi-with-table",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      data={value}
                    />
                  ))}
                </div>
              );
            case "multi-pie-1":
              return (
                <div>
                  {Object.entries(dataChart).map(([key, value]) => (
                    <MultiPieChart
                      key={key}
                      title={key}
                      dataSetting={{
                        chartTemplate: "multi-pie-1",
                        name: name + "_" + getCategoryLabelById(key),
                        formFormulaId: formFormulaId,
                        year,
                      }}
                      data={value}
                    />
                  ))}
                </div>
              );

            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};
